module.exports = __webpack_public_path__ + "static/img/rlnl.b5c2970c.png";